import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Download, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PublicVideo() {
    const { token } = useParams();
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        axios.get(`${BACKEND}/api/public/vtour/${token}`)
            .then(({ data }) => setData(data))
            .catch(() => setError(true));
    }, [token]);

    return (
        <div className="min-h-screen bg-[#0D0F13] text-white flex flex-col" data-testid="public-video-page">
            <header className="flex items-center justify-between px-5 py-4">
                <p className="text-sm font-bold truncate" data-testid="public-video-title">
                    {data?.address_label || data?.location_label || ""}
                </p>
                <div className="flex items-center gap-4 shrink-0">
                    {data?.result_url && (
                        <a href={`${BACKEND}${data.result_url}?dl=${encodeURIComponent(data.filename || "videotour.mp4")}`}
                            className="inline-flex items-center gap-1.5 text-xs text-zinc-300 hover:text-white transition"
                            data-testid="public-video-download-btn">
                            <Download className="h-3.5 w-3.5" /> Download
                        </a>
                    )}
                    <a href="https://vastgoed.social-factory.be" target="_blank" rel="noreferrer"
                        className="hover:opacity-75 transition" data-testid="public-video-logo-link">
                        <img src="/social-factory-logo.png" alt="Social Factory" className="h-9" />
                    </a>
                </div>
            </header>
            <main className="flex-1 flex items-center justify-center px-4 pb-8">
                {error ? (
                    <p className="text-sm text-zinc-400" data-testid="public-video-error">Deze video is niet (meer) beschikbaar.</p>
                ) : !data ? (
                    <Loader2 className="h-6 w-6 animate-spin text-zinc-500" />
                ) : (
                    <video src={`${BACKEND}${data.result_url}`} controls autoPlay playsInline preload="auto"
                        className={`rounded-md bg-black ${data.aspect === "9:16" ? "max-h-[85vh]" : "w-full max-w-5xl max-h-[85vh]"}`}
                        data-testid="public-video-player" />
                )}
            </main>
        </div>
    );
}
